import React, { Component } from "react";
import emailjs from "emailjs-com";
import {
  Row,
  Col,
  Container,
  Image,
  Form,
  InputGroup,
  Button,
  Modal,
} from "react-bootstrap";

import Checkmark from "../../assets/png/Checkmark.png";

import styles from "./OurServices.module.scss";

interface AppProps {
  //code related to your props goes here
}

interface AppState {
  from_name: string;
  reply_to: string;
  message: string;
  validated: boolean;
  setValidated: boolean;
  showModal: boolean;
}

export default class OurServices extends Component<AppProps, AppState> {
  constructor(props: any) {
    super(props);
    this.state = {
      from_name: "",
      reply_to: "",
      message: "",
      validated: false,
      setValidated: false,
      showModal: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getInitialState = this.getInitialState.bind(this);
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  handleChange(event: any) {
    this.setState({
      from_name: event.target.from_name,
      reply_to: event.target.reply_to,
      message: event.target.message,
    });
  }

  handleSubmit(event: any) {
    event.preventDefault();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.setState({ validated: true, setValidated: false });

    if (form.checkValidity() === true) {
      this.setState({ validated: true, setValidated: true });
      this.sendEmail(event);
      this.open(event);
    }
  }

  sendEmail(event: any) {
    event.preventDefault();
    emailjs
      .sendForm(
        "service_vzrys0g",
        "template_5l0vzwn",
        event.target,
        "user_UnMrOj4qO3hh0G3UyNAoe"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    this.setState({
      from_name: "",
      reply_to: "",
      message: "",
      validated: false,
      setValidated: false,
    });
  }

  getInitialState(event: any) {
    return { showModal: false };
  }

  close(event: any) {
    this.setState({ showModal: false });
  }

  open(event: any) {
    this.setState({ showModal: true });
  }

  render() {
    return (
      <section id={styles.OurServices}>
        <Container fluid>
          <Row>
            <Col lg={6} id={styles.Box1}>
              <div className={styles.vl}></div>
              <p id={styles.Header}>
                Our<br></br>Services
              </p>
              <br></br>
              <p id={styles.SubHeader}>CONSULTATIONS & ASSESSMENTS</p>
              <br></br>

              <p className={styles.content}>
                Lead a more carbon-conscious business with Agrinol.
              </p>

              <p className={styles.content}>
                Agrinol provides an array of services to help your business go
                green(er). We offer{" "}
                <b>carbon tax consultations and specialized estimations</b> for
                companies and governments seeking to understand their fuel usage
                and carbon footprint, and reduce their carbon tax.
              </p>

              <p className={styles.content}>
                Agrinol also offers{" "}
                <b>consultations for various fruits and vegetables,</b>{" "}
                including exotic and rare species. Experimentation and analysis
                for use of our AgriFresh product are available.
              </p>
            </Col>

            <Col lg={6} id={styles.Box2}>
              <div id="OurServices"></div>
              <p className={styles.formHeader} id="ContactUs">
                For questions, comments, concerns or to place an order, please
                complete the following form:
              </p>
              {/* <input
                  className={styles.inputStyle}
                  type="hidden"
                  name="contact_number"
                />
                <label className={styles.labelStyle}>Name</label>
                <input
                  className={styles.inputStyle}
                  type="text"
                  name="from_name"
                  placeholder="Name"
                  value={this.state.from_name}
                  onChange={this.handleChange}
                />
                <label className={styles.labelStyle}>Email</label>
                <input
                  className={styles.inputStyle}
                  type="email"
                  name="reply_to"
                  placeholder="Email"
                  value={this.state.reply_to}
                  onChange={this.handleChange}
                />
                <label className={styles.labelStyle}>Message</label>
                <textarea
                  className={styles.textareaStyle}
                  name="message"
                  placeholder="For questions, comments, concerns or to place an order..."
                  value={this.state.message}
                  onChange={this.handleChange}
                /> */}
              {/* <input
                  className={styles.inputStyle}
                  type="submit"
                  value="Send"
                /> */}
              <Form
                noValidate
                validated={this.state.validated}
                onSubmit={this.handleSubmit}
                className={styles.contactForm}
              >
                <Form.Row style={{ height: "109px" }}>
                  <Form.Group
                    as={Col}
                    md="12"
                    value={this.state.from_name}
                    onChange={this.handleChange}
                  >
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      as="input"
                      required
                      name="from_name"
                      type="text"
                      placeholder="Name"
                      value={this.state.from_name}
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
                <Form.Row style={{ height: "109px" }}>
                  <Form.Group
                    as={Col}
                    md="12"
                    value={this.state.reply_to}
                    onChange={this.handleChange}
                  >
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      as="input"
                      required
                      name="reply_to"
                      type="text"
                      placeholder="Email"
                      value={this.state.reply_to}
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
                <Form.Row style={{ height: "196px" }}>
                  <Form.Group
                    as={Col}
                    md="12"
                    value={this.state.message}
                    onChange={this.handleChange}
                  >
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      required
                      type="text"
                      name="message"
                      placeholder="For questions, comments, concerns or to place an order..."
                      rows={3}
                      className={styles.textareaStyle}
                      value={this.state.message}
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
                <Button className={styles.inputStyle} type="submit">
                  Submit
                </Button>
              </Form>
              <Modal show={this.state.showModal} onHide={this.close}>
                <Modal.Body id={styles.ModalBody}>
                  <Image
                    src={Checkmark}
                    width={1500}
                    height={1500}
                    id={styles.Checkmark}
                  ></Image>
                  <p id={styles.Message}>
                    Thank you for contacting Agrinol! <br></br>
                    We value your enquiry and will get back to you as soon as we
                    can.
                  </p>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    onClick={this.close}
                    id={styles.InputStyle}
                    value="Close"
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
